import { DOCTYPES } from '@/constants/doctypes'
import { createDoctypeRoutes } from '@/routers/routes/createDoctypeRoutes'

const {
  create: routeItemPriceCreate,
  detail: routeItemPriceDetail,
  home: routeItemPricesHome,
  root: routeItemPricesRoot,
} = createDoctypeRoutes({
  createName: 'new-item-price',
  createPath: 'new-item-price',
  detailName: 'itemPriceDetail',
  doctype: DOCTYPES.ITEM_PRICE,
  homeName: 'item-prices',
  path: 'item-prices',
  views: {
    create: async () => await import('@/components/viewsExternal/itemPrices/AddItemPrice.vue'),
    detail: async () => await import('@/components/viewsExternal/itemPrices/ViewItemPrice.vue'),
    list: async () => await import('@/components/viewsExternal/prices/ViewPrices.vue'),
  },
})

export { routeItemPriceCreate, routeItemPriceDetail, routeItemPricesHome, routeItemPricesRoot }
